import styled, { css } from 'styled-components';
import media from '../../constants/media';
import theme from '../../constants/theme';
import { P } from '../base/typography';

export const EventItem = styled.div`
	display: grid;
	grid-template-columns: 12rem 30px auto;
	${media.mobileOnly`grid-template-columns: 30px auto;`};
`;

export const FillerL = styled.div`
	${media.mobileOnly`display: none;`};
`;

export const LineWrapper = styled.span`
	height: 5rem;
	margin: -1rem 0;
	${media.mobileOnly`
		height: 8rem;
		margin: -3rem 0;
	`};
`;

export const Line = styled.div`
	height: 100%;
	width: 0px;
	margin: 0 auto;
	border-color: ${theme.colors.gray} !IMPORTANT;
	border: 2px dashed;
`;

export const Dot = styled.div`
	height: 20px;
	width: 20px;
	line-height: 18px;
	margin: auto;
	padding-left: -1px;
	border: 2px solid ${theme.colors.gray};
	border-radius: 100%;
	font-size: 1.2rem;
	font-weight: bold;
	text-align: center;
	color: ${theme.colors.gray};

	${({ current }) =>
		current &&
		css`
			background-color: ${theme.colors.secondary};
			position: relative;
			border: 0;

			&:before {
				background: none;
				border: 3px solid #fff;
				content: '';
				display: block;
				position: absolute;
				border-radius: 100%;
				top: 2px;
				left: 2px;
				right: 2px;
				bottom: 2px;
				pointer-events: none;
			}
		`};

	${({ historic }) =>
		historic &&
		css`
			border-color: ${theme.colors.secondary} !IMPORTANT;
			color: ${theme.colors.secondary};
		`};

	${({ future }) =>
		future &&
		css`
			${media.tablet`
				margin-top: 1.5rem;
				margin-bottom: 1.5rem;
			`}
		`};
`;

export const EventDateWrapper = styled.div`
	${media.mobileOnly`display: none;`};
`;

export const EventDate = styled.div`
  color: ${({ theme: localTheme }) => localTheme.colors.black};
  ${({ historic, theme: localTheme }) =>
    historic &&
    css`
      color: ${localTheme.colors.gray};
    `}
`;

export const EventTime = styled.div`
  color: ${({ theme: localTheme }) => localTheme.colors.gray};
`;

export const MobileEventDate = styled(P)`
  padding-left: 2rem;
  text-align: left;
  span {
    font-size: 1.5rem;
  }
  ${media.tablet`
    display: none;
  `}
  ${({ historic, theme: localTheme }) =>
    historic &&
    css`
      color: ${localTheme.colors.gray};
    `}
`;

export const EventsWrapper = styled.div`
  ${media.mobileOnly`min-height: 9rem;`}
  margin: auto 0;
`;

export const EventLocation = styled.div`
  padding-left: 2rem;
  flex: 0 0 auto;
  color: ${({ theme: localTheme }) => localTheme.colors.black};
  ${({ historic, theme: localTheme }) =>
    historic &&
    css`
      color: ${localTheme.colors.gray};
    `}
`;


export const EventDescription = styled.div`
	padding-left: 2rem;
`;

export const GetMoreButton = styled.span`
		user-select: none;
    margin-bottom: 2rem;
		${media.mobileOnly`margin-bottom: 3rem`};
  	color: ${({ theme }) => theme.colors.primaryLight};
		text-overflow: clip;
		justify-self: center;
		white-space: nowrap;
		&:hover {
        color: ${({ theme }) => theme.colors.primary};
        cursor: pointer;
		}
		// The text in this button (span) is overflowing and without z-index the grid col to the right will be in front
		//   making it not clickable in the overflowed area
    z-index: 1;
`;